// A pre-project counts as "new" for 7 days after its creation.
const NEW_PRE_PROJECT_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

// The pre-project itself was created within the last 7 days. `createdAt` comes as epoch
// milliseconds (an ISO string also parses). Editing a cost span never makes it new again.
export function isNewPreProject(preProject, now = Date.now()) {
  if (!preProject.createdAt) return false;
  const createdAt = new Date(preProject.createdAt).getTime();
  if (Number.isNaN(createdAt)) return false;
  const age = now - createdAt;
  return age >= 0 && age < NEW_PRE_PROJECT_WINDOW_MS;
}

// The table's budget columns (`{ year, amount, span, … }` each) as lines to list: a budget over
// whole years, which the table repeats in each year's column, shows once with its span
// ("2026–2036").
export function budgetLines(budgets) {
  const lines = budgets.map((budget) => ({
    ...budget,
    when: budget.span || String(budget.year),
    key: `${budget.span || budget.year}|${budget.amount}`,
  }));
  return lines.filter((line, index) => lines.findIndex((other) => other.key === line.key) === index);
}

// Some imports carry "-" as a placeholder project number — treat it as absent.
export function hasProjectNumber(preProject) {
  const projectNumber = (preProject.projectNumber || '').trim();
  return !!projectNumber && projectNumber !== '-';
}
